/** Set once the last cohort is on the redesign; null keeps the date out of all copy. */
export const REDESIGN_CLASSIC_SUNSET: Date | null = null;

export const REDESIGN_REVERT_REASONS = [
  "I couldn't find something",
  'It slowed me down',
  'Something looked broken',
  'I prefer how classic looks',
  'Something else',
] as const;
